import { css } from "@emotion/react";


export const notPrintable = css({
    '@media print': {
        display: 'none',
    }
})